import { Box, Icon, Typography } from '@mui/material'

const Tags = ({ icon, word, sx, sxIcon, rest, typo = 'body2', textColor }) => {
  return (
    <Box
      display="flex"
      columnGap={1}
      alignItems="center"
      padding={0.5}
      bgcolor="gray-background.main"
      sx={{
        borderRadius: '1.5px',
        ...sx,
      }}
      {...rest}
    >
      <Icon
        sx={{
          color: 'alternate.main',
          fontSize: sxIcon?.fontSize ?? '15px',
          ...sxIcon,
        }}
      >
        {icon}
      </Icon>
      <Typography variant={typo} color={textColor ?? 'light-gray-text.main'}>
        {word}
      </Typography>
    </Box>
  )
}
export default Tags
